var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.canInstall && _vm.isMobile)?_c('button',{staticClass:"install-btn",on:{"click":_vm.installPwa}},[_vm._v(" Instalar app ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }